import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-combo-especial-correo',
  templateUrl: './combo-especial-correo.component.html',
  styleUrls: ['./combo-especial-correo.component.scss']
})

export class ComboEspecialCorreoComponent {

  @Input("correos") correos: string[] = [];
  agregando_direccion: boolean = false;
  model_value: string = "";
  mensaje_error: string = "";
  @Output("nuevoEmail") nuevoEmail: EventEmitter<string> = new EventEmitter<string>();
  @Output("eliminarMail") eliminarMail: EventEmitter<string> = new EventEmitter<string>();

  nuevaDireccion() {
    this.model_value = "";
    this.agregando_direccion = true;
  }

  agregar() {
    if (this.validarCorreo()) {
      this.mensaje_error = "";
      this.nuevoEmail.emit(this.model_value);
      this.agregando_direccion = false;
    } else {
      this.mensaje_error = "El formato de correo no es válido."
    }
  }

  eliminarCorreoEmitter(correo: string) {
    this.eliminarMail.emit(correo);
  }

  validarCorreo() {
    // Expresión regular para validar el formato del email
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return regex.test(this.model_value);
  }

}
